(() => {
  'use strict';
  if (window.AWCommerceFailsafe?.version) return;

  const state = { degraded: false, reasons: [] };

  const nativeCommerceForm = (node) => {
    const form = node?.closest?.('form');
    if (!form) return null;
    const action = new URL(form.getAttribute('action') || location.pathname, location.origin).pathname;
    return /\/cart(?:\/add)?\/?$/.test(action) ? form : null;
  };

  const degrade = (reason) => {
    if (!state.reasons.includes(reason)) state.reasons.push(reason);
    if (state.degraded) return;
    state.degraded = true;
    document.documentElement.dataset.awCommerceMode = 'shopify-native';
    window.dispatchEvent(new CustomEvent('aw:commerce-failsafe', { detail: { reason, mode: 'shopify-native' } }));
  };

  // Prefer native Shopify commerce whenever client runtime health is uncertain.
  window.addEventListener('error', () => degrade('client-runtime-error'), true);
  window.addEventListener('unhandledrejection', () => degrade('unhandled-rejection'), true);

  document.addEventListener('submit', (event) => {
    if (!state.degraded) return;
    const form = nativeCommerceForm(event.target);
    if (!form || !form.checkValidity()) return;
    event.stopImmediatePropagation();
  }, true);

  document.addEventListener('click', (event) => {
    if (!state.degraded) return;
    const control = event.target.closest?.('button[type="submit"], input[type="submit"], [data-aw-quick-add], [data-aw-add-selected]');
    const form = nativeCommerceForm(control);
    if (!form) return;
    event.stopImmediatePropagation();
  }, true);

  window.AWCommerceFailsafe = Object.freeze({
    version: '1.1.0',
    get degraded() { return state.degraded; },
    get reasons() { return state.reasons.slice(); },
    degrade
  });
})();